var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4658_312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 19.5C38 8.73045 29.4934 0 19 0C8.50659 0 0 8.73045 0 19.5C0 30.2696 8.50659 39 19 39C29.4934 39 38 30.2696 38 19.5Z",
    fill: "#CAEFE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6252 30.3103H18.5866C18.5643 30.2829 18.5317 30.2813 18.502 30.2707C15.7217 29.2469 12.9415 28.2232 10.1613 27.1994C9.95495 27.1232 9.75011 27.0456 9.54229 26.9724C9.48737 26.9526 9.46362 26.9252 9.47253 26.8673C9.47253 26.8582 9.47253 26.8475 9.47253 26.8384C9.47253 22.0837 9.47253 17.3275 9.47253 12.5729C9.47253 12.5038 9.50321 12.4581 9.56456 12.4358C12.8614 11.1942 16.1582 9.95106 19.4549 8.70793C19.5158 8.68508 19.5678 8.68508 19.6271 8.70793C22.5335 9.77586 25.44 10.8438 28.3464 11.9117C28.3998 11.9315 28.4562 11.9452 28.5067 11.9772C28.4755 12.0077 28.4369 12.0138 28.4028 12.026C25.1787 13.2463 21.9546 14.465 18.7306 15.6853C18.6059 15.7325 18.6267 15.7051 18.6252 15.8422C18.6252 15.8559 18.6252 15.8681 18.6252 15.8818C18.6252 20.6441 18.6252 25.4048 18.6252 30.1671C18.6252 30.2158 18.6252 30.2646 18.6252 30.3133V30.3103Z",
    fill: "#00E599"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5283 12.6765V27.4081C28.4897 27.4249 28.46 27.4005 28.4288 27.3898C27.6109 27.0897 26.793 26.7881 25.9736 26.4864C23.8094 25.6897 21.6437 24.8914 19.4795 24.0947C19.4706 24.0916 19.4617 24.0886 19.4528 24.0855C19.3741 24.0566 19.3741 24.0566 19.3741 23.9682C19.3741 21.3905 19.3741 18.8114 19.3741 16.2337C19.3741 16.1423 19.3563 16.1484 19.4661 16.1057C21.6556 15.2739 23.8451 14.4421 26.036 13.6104C26.8331 13.3072 27.6302 13.0055 28.4288 12.7024C28.4585 12.6917 28.4852 12.6734 28.5283 12.6765Z",
    fill: "#00AF92"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4658_312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 39,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNeo);
export default __webpack_public_path__ + "static/media/iconNeo.a5f0bdb0c40d682b525f90689e2ecfe6.svg";
export { ForwardRef as ReactComponent };